import type React from "react"

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function Alert({ children, className = "", ...props }: AlertProps) {
  return (
    <div className={`relative w-full rounded-lg border p-4 ${className}`} role="alert" {...props}>
      {children}
    </div>
  )
}

interface AlertDescriptionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function AlertDescription({ children, className = "", ...props }: AlertDescriptionProps) {
  return (
    <div className={`text-sm ${className}`} {...props}>
      {children}
    </div>
  )
}
